import styles from "./Partners.module.css";
import partner1 from "../../../../assets/partners/Bohemia.jpg";
import partner2 from "../../../../assets/partners/Bild_2023-04-08_235910259.png";
import partner3 from "../../../../assets/partners/WAS1.png";
import partner4 from "../../../../assets/partners/bartscher.png";
import partner5 from "../../../../assets/partners/logo-gihale.gif";
import { useEffect, useState } from "react";

const partneri = [partner1, partner2, partner3, partner4, partner5];

export default function Partners({ dataCtx }) {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    if (
      dataCtx.galleries !== -1 &&
      dataCtx.galleries !== -2 &&
      dataCtx.galleries.length > 0
    ) {
      setPartners(
        dataCtx.galleries.filter((e) => e.post_name === "partneri-2")[0].gallery
      );
    }
  }, [dataCtx.galleries]);

  return (
    <main className={styles.main}>
      <div className={styles.id} id="partners"></div>
      <div className={styles.title}>{dataCtx.pageData.partners.title}</div>
      <div className={styles.container}>
        {partners.length > 0 &&
          partners.map((partner, i) => {
            return (
              <img
                key={i}
                onClick={() => {
                  window.open(partner.alt, "_blank");
                }}
                className={`${styles[`partner-img`]} ${
                  styles[
                    i !== parseInt(partners.length / 2)
                      ? `partner1`
                      : `partner2`
                  ]
                }`}
                src={partner.src}
                alt="Partner."
              />
            );
          })}
      </div>
    </main>
  );
}
